import {
  Tag,
  TagSize,
  TagVariant
} from '@deliveryhero/pd-cookbook/components/Tag';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';

import classNames from 'classnames';
import { mapSubscriptionDurationToMonth } from 'src/utils/format-user-subscription-details';

import { TierCardProps } from './types';

import './styles.scss';

export const TierCard = ({
  tier,
  currencyCode,
  value,
  selectedValue,
  onClick
}: TierCardProps) => {
  const isSelected = selectedValue == value;

  return (
    <div
      className={classNames('tier-card-container', {
        'tier-card-container--selected': isSelected
      })}
      onClick={onClick}
    >
      <Typography
        type="title-md"
        as="div"
        className={classNames('tier-card-header', {
          'tier-card-header--selected': isSelected
        })}
      >
        {mapSubscriptionDurationToMonth(tier.duration_months)}
      </Typography>
      <div
        className={classNames('tier-card-body', {
          'tier-card-body--selected': isSelected
        })}
      >
        <Typography type="title-xl" as="div" paddingBottom="st" paddingTop="st">
          {currencyCode} {tier.monthly_price}{' '}
          <Typography type="label-md" as="span">
            / month
          </Typography>
        </Typography>

        <Tag
          id="price"
          label={`${currencyCode} ${tier.billed_price} every ${
            tier.duration_months > 1 ? tier.duration_months : ''
          } month${tier.duration_months > 1 ? 's' : ''}`}
          size={TagSize.SMALL}
          variant={TagVariant.SECONDARY}
          marginBottom="md"
        />
      </div>
    </div>
  );
};
